// extracted by mini-css-extract-plugin
module.exports = {"machineInfo":"Machine_machineInfo__1zo18","machineName":"Machine_machineName__2y7OZ","machineGroup":"Machine_machineGroup__2IsgF"};